enum TextSize {
  LARGE = "large",
  MEDIUM = "medium",
  SMALL = "small",
}

export default TextSize;
